module.exports = __webpack_public_path__ + "static/media/weebly.0b2ffb1c.svg";